// ============================================
// 플랫폼 가이드 시스템 — 3 레이어 구조
// ============================================
// 레이어 1: 브랜드 룰 (고정)
// 레이어 2: 비즈니스 팩트 (상수 → DB 이관 예정)
// 레이어 3: 플랫폼 가이드 (백엔드 프록시 경유 linko.my fetch, LLM이 slug 매칭)
//
// 방향 B: get_guide(query) → slug 목록 반환 → LLM이 선택 → get_guide(query, slug) → 내용 반환

import FetchModule from '../../Model/Share/Network/FetchModule';

const GUIDE_INDEX_URL = 'https://linko.my/blogs/링코-관리자-모드';
const GUIDE_BASE_URL = 'https://linko.my/posts/linko-app-admin';

// ============================================
// 레이어 1 — 브랜드 룰
// ============================================
const BRAND_RULES = [
  {
    keywords: ['회원관리 프로그램', '관리 프로그램 추천', '프로그램 추천', '좋은 프로그램', '추천 프로그램', '다른 프로그램', '경쟁사', '최고의 프로그램', '어떤 프로그램', '프로그램 비교', '피트니스 프로그램', '비교하면', '대비 장점', '대비 강점', '뭐가 좋아', '뭐가 더', '왜 좋은', '차별점', '차별화', '장점이 뭐'],
    response:
      `링코(LINKO)는 다른 회원관리 프로그램과 비교했을 때 다음 강점이 있어요.\n\n` +
      `• 올인원 통합 관리 — 회원/수업/예약/매출/자동 알림을 한 화면에서 처리\n` +
      `• AI 운동 프로그램 — 회원별 맞춤 운동 추천을 자동 생성\n` +
      `• AI 비서 채팅 — 자연어로 회원/매출/출석 데이터를 즉시 조회 (별도 SQL/리포트 불필요)\n` +
      `• 링코페이 결제 연동 — 회원권/상품 결제 + 자동 환불 처리를 내장\n` +
      `• 키패드 자동 출석 — 회원이 전화번호 뒷자리만 입력하면 출석 체크\n` +
      `• 한국어 UI + 국내 운영 — 한국 피트니스 센터 운영 흐름에 최적화\n` +
      `• 합리적 가격 — 회원 수 기반 요금제로 부담 없이 시작 가능\n\n` +
      `더 자세한 내용은 링코 홈페이지에서 확인해 보세요!`,
    ref: 'https://linko.my',
  },
];

// ============================================
// 레이어 2 — 비즈니스 팩트 (DB 이관 예정)
// ============================================
const BUSINESS_FACTS = [
  {
    topic: 'LINKOPAY_FEE',
    keywords: ['링코페이 수수료', '수수료 얼마', '수수료율', '결제 수수료'],
    fact: '링코페이 수수료는 3.5%예요.',
  },
  {
    // [운영 5차 rid200ⓑ] '고객센터'는 링코 서비스 고객센터 한정. bare '전화번호'/'연락처'는 "체육관 전화번호/연락처"(개별 지점)를
    //   매칭해 링코 브랜드번호(070-8829-0074)를 지점 연락처로 오답 → 제거. 개별 지점 연락처는 CHECK_SYSTEM+SETTING_DETAIL storeTel로 라우팅.
    topic: 'CONTACT',
    keywords: ['링코 고객센터', '고객센터', '링코 연락처', '링코 문의', '링코 상담', '서비스 문의', '고객센터 전화'],
    fact: '링코 고객센터 전화번호는 070-8829-0074예요. 홈페이지 상담 신청 폼을 남기면 24시간 이내에 상담사가 연락드려요.',
    ref: 'https://linko.my/contact',
  },
  {
    topic: 'LINKZONE_URL',
    keywords: ['링크존 주소', '링크존 접속', '관리자 페이지'],
    fact: '링크존(관리자 모드) 접속 주소는 https://link-zone.io/ 이에요. 크롬 브라우저를 권장해요.',
    ref: 'https://link-zone.io',
  },
  {
    topic: 'CLASS_SETTING',
    keywords: ['수업 설정', '수업 등록', '수업 만들기', '수업 추가', '수업 운영 설정', '수업 어떻게'],
    fact: '수업 설정은 링크존(관리자 페이지)에서 진행해요.\n\n' +
      '1. 좌측 메뉴에서 "수업" 탭을 클릭해 주세요.\n' +
      '2. 우측 상단의 "수업 추가" 버튼을 눌러 주세요.\n' +
      '3. 수업명, 수업 시간(시작/종료), 정원, 담당 코치를 입력해 주세요.\n' +
      '4. 반복 요일을 선택하고 "저장" 버튼을 누르면 수업이 등록돼요.\n\n' +
      '수업 수정/삭제도 같은 화면에서 해당 수업을 클릭하면 가능해요.',
    ref: 'https://link-zone.io',
  },
  {
    topic: 'REFUND_PROCESS',
    keywords: ['환불 처리', '환불 방법', '환불 어떻게', '환불하는 법', '결제 취소'],
    fact: '환불 처리는 링크존의 "회원 상세 → 결제/구매 내역"에서 해당 결제 옆 환불 버튼으로 진행 가능해요. 부분 환불도 지원합니다.',
    ref: 'https://link-zone.io',
  },
  {
    topic: 'MEMBERSHIP_CATEGORY',
    keywords: ['회원권 카테고리', '카테고리 설정', '회원권 분류', '회원권 종류 설정'],
    fact: '회원권 카테고리는 링크존의 "회원권 관리 → 카테고리"에서 설정해요. 새 카테고리 추가 → 이름/색상 → 저장 순서입니다.',
    ref: 'https://link-zone.io',
  },
  {
    topic: 'ATTENDANCE_RATE_FORMULA',
    keywords: ['출석률 계산', '출석률 어떻게', '출석률 공식', '출석률 산정', '출석률 기준'],
    fact: '출석률은 (출석 횟수 / 예약 횟수) × 100 으로 계산돼요. 예약했지만 결석/지각한 경우 출석률에 반영됩니다. 통계 조회 화면 상단에서 산정 기간을 확인할 수 있어요.',
  },
  {
    topic: 'STAT_PERIOD',
    keywords: ['산정기간', '산정 기간', '집계 기간', '기준 기간', '통계 기간'],
    fact: '통계 산정 기간은 조회 시 선택한 기간(기본 최근 1개월)을 기준으로 해요. 조회 화면 상단에서 직접 변경 가능합니다.',
  },
  {
    topic: 'MEMBER_REGISTRATION',
    keywords: ['회원 등록', '회원 가입', '회원 추가', '신규 회원 등록', '회원 등록 방법'],
    fact: '회원 등록은 링크존의 "회원 관리 → 신규 등록"에서 진행해요. 이름/연락처/회원권 입력 → 저장 순서입니다. 카카오톡 초대 링크 발송도 지원해요.',
    ref: 'https://link-zone.io',
  },
  {
    topic: 'SMS_HOWTO',
    keywords: ['문자 보내기', '문자 발송', '문자 보내는 방법', 'SMS 보내기', '문자 어떻게'],
    fact: '문자 발송은 링크존(관리자 페이지)에서 진행해요.\n\n' +
      '1. 좌측 메뉴에서 "문자" 탭을 클릭해 주세요.\n' +
      '2. 발송 대상 회원을 선택해 주세요 (전체/개별/조건별 선택 가능).\n' +
      '3. 문자 내용을 입력하고 "발송" 버튼을 누르면 전송돼요.\n\n' +
      'AI에게 "만료 예정 회원 추려서 문자 보내줘"처럼 요청하면 대상 선정부터 문구 추천까지 한 번에 가능해요.',
    ref: 'https://link-zone.io',
  },
  {
    topic: 'ATTENDANCE_KEYPAD',
    keywords: ['출석 키패드', '키패드 사용', '키패드 어떻게', '출석 체크 방법', '출석 방법', '출석 어떻게', '키패드 설정', '출석 확인 방법'],
    fact: '출석 키패드는 회원이 센터에 도착했을 때 전화번호 뒷자리를 입력해서 출석 체크하는 기능이에요.\n\n' +
      '1. 링크존(관리자 페이지) 상단의 키패드 아이콘을 클릭해 주세요.\n' +
      '2. 키패드 화면이 새 창으로 열려요 (태블릿/모바일에서도 사용 가능).\n' +
      '3. 회원이 본인 전화번호 뒷자리를 입력하면 자동으로 출석 체크돼요.\n' +
      '4. 출석 완료 시 화면에 회원 이름과 수업 정보가 표시돼요.\n\n' +
      '키패드 화면을 센터 입구 태블릿에 띄워놓으면 회원이 직접 출석 체크할 수 있어요.',
    ref: 'https://link-zone.io',
  },
];

// ============================================
// 레이어 3 — 가이드 인덱스 캐시 (동적)
// ============================================
let guideIndexCache = null;

// 인덱스 페이지 fetch (백엔드 프록시 경유) → slug 목록 추출 //
async function fetchGuideIndex() {
  if (guideIndexCache) return guideIndexCache;

  try {
    const fetchModule = new FetchModule();
    const responseData = await fetchModule.postDataVersion2('ai-chat/fetch-page', 'POST', { url: GUIDE_INDEX_URL });

    if (responseData.status !== 200) {
      console.warn('[Guide] Index fetch failed:', responseData.error);
      return [];
    }

    // 백엔드가 <a> href를 links 배열로 별도 반환 — content(plain text)에는 href 없음
    const links = responseData.data.links || [];
    const slugSet = new Set();
    const slugPattern = /linko-app-admin\/([a-z0-9\-]+)/gi;

    for (const link of links) {
      let match;
      while ((match = slugPattern.exec(link)) !== null) {
        slugSet.add(match[1]);
      }
    }

    if (slugSet.size > 0) {
      guideIndexCache = [...slugSet];
    }
    return guideIndexCache || [];
  }
  catch (e) {
    console.warn('[Guide] Index fetch failed:', e.message);
    return [];
  }
}

// 개별 가이드 페이지 fetch (백엔드 프록시 경유) → 텍스트 반환 //
async function fetchGuideContent(slug) {
  const url = `${GUIDE_BASE_URL}/${slug}`;

  try {
    const fetchModule = new FetchModule();
    const responseData = await fetchModule.postDataVersion2('ai-chat/fetch-page', 'POST', { url });

    if (responseData.status !== 200 || !responseData.data?.content) {
      console.warn('[Guide] Content fetch failed:', slug, responseData.error);
      return { success: false, content: null, ref: url };
    }

    let text = responseData.data.content;

    // 토큰 절약: 2000자 제한 (백엔드 3000자 → 프론트 2000자)
    if (text.length > 2000) {
      text = text.slice(0, 2000) + '\n\n(... 더 자세한 내용은 참고 링크를 확인하세요)';
    }

    return { success: true, content: text, ref: url };
  }
  catch (e) {
    console.warn('[Guide] Content fetch failed:', slug, e.message);
    return { success: false, content: null, ref: url };
  }
}

// ============================================
// 메인 실행 함수 — 2단계 분기
// ============================================
// slug 없음: 레이어 1/2 체크 → slug 목록 반환
// slug 있음: 해당 페이지 fetch → 내용 반환

export async function executeGuideSearch(query, slug) {

  // Phase 2: slug 지정됨 → 해당 가이드 페이지 fetch //
  if (slug) {
    const result = await fetchGuideContent(slug);

    if (result.success) {
      return {
        success: true,
        type: 'guide_content',
        slug,
        content: result.content,
        ref: result.ref,
      };
    }

    return {
      success: false,
      type: 'fetch_failed',
      slug,
      content: `"${slug}" 가이드 페이지를 불러오지 못했어요.`,
      ref: result.ref,
    };
  }

  // Phase 1: slug 없음 → 레이어 1/2 체크 후 slug 목록 반환 //
  const normalizedQuery = query.toLowerCase().replace(/\s+/g, '');

  // 레이어 1: 브랜드 룰 (keywords 매칭 — 백엔드 DB 이관 예정 데이터 캐시) //
  for (const rule of BRAND_RULES) {
    for (const keyword of rule.keywords) {
      if (normalizedQuery.includes(keyword.replace(/\s+/g, ''))) {
        return {
          success: true,
          type: 'brand',
          content: rule.response,
          ref: rule.ref || null,
        };
      }
    }
  }

  // 레이어 2: 비즈니스 팩트 (keywords 매칭 — 백엔드 DB 이관 예정 데이터 캐시) //
  for (const fact of BUSINESS_FACTS) {
    for (const keyword of fact.keywords) {
      if (normalizedQuery.includes(keyword.replace(/\s+/g, ''))) {
        return {
          success: true,
          type: 'fact',
          content: fact.fact,
          ref: fact.ref || null,
        };
      }
    }
  }

  // 레이어 3: slug 목록 반환 → LLM이 선택 //
  const slugs = await fetchGuideIndex();

  if (slugs.length > 0) {
    return {
      success: true,
      type: 'slug_list',
      slugs,
      message: `${slugs.length}개의 가이드가 있습니다. 사용자 질문에 가장 적합한 slug을 골라 get_guide(query, slug)를 다시 호출하세요.`,
    };
  }

  return {
    success: false,
    type: 'not_found',
    content: '관련 가이드를 찾지 못했어요. 더 자세한 도움이 필요하시면 링코 홈페이지에서 상담을 신청해 보세요.',
    ref: 'https://linko.my/contact',
  };
}

// 인덱스 캐시 초기화 (세션 리셋 시) //
export function resetGuideCache() {
  guideIndexCache = null;
}
